import Icon from '../components/Icon.vue'

Icon.register({
  bold: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M333.5 238c34.4 27.5 55.6 71.2 50.8 119.6-6.9 70.7-70.2 122.4-141 122.4h-209.3c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h31.9v-288h-31.9c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h199.4c74.6 0 134.4 64.5 127.1 140.8-2 20.3-14.1 49.5-27 65.2zM145.7 112v96h87.8c26.5 0 48-21.5 48-48s-21.5-48-48-48h-87.8zM233.4 400c30.9 0 56-25.1 56-56s-25.1-56-56-56h-87.8v112h87.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bold.js
// module id = 669
// module chunks = 0